export interface SubscriptionPlan {
    id: ID;
    package: SubscriptionPackage;
}

interface SubscriptionPackage {
    type: SubscriptionPackageType;
}

export enum SubscriptionPackageType {
    FLEX_STANDARD = "free",
    FLEX_LEVEL = "flex_level",
    PAYG = "payg",
    PROFESSIONAL = "professional",
    PREMIUM = "premium",
    PLUS = "plus",
    ENTERPRISE = "enterprise",
    ENTERPRISE_RECURRING = "enterprise_recurring",
    ENTERPRISE_CUSTOM = "enterprise_custom",
    ENTERPRISE_CHILD = "child",
}
